// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8mZ6n3iGBpR1bPKpOIPMnMRMcjXl03lY",
  authDomain: "kingdom-of-ants.firebaseapp.com",
  projectId: "kingdom-of-ants",
  storageBucket: "kingdom-of-ants.appspot.com",
  messagingSenderId: "395348864801",
  appId: "1:395348864801:web:3fdbd37605b9ef76f71860",
  measurementId: "G-VHX0EC9KXC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };